import React from 'react';
import BaseIcon from './BaseIcon';


const PreviewIcon = props => (
  <BaseIcon {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path d="M8,14 C4.78670691,14 1,12 0,8 C1,4 4.78670691,2 8,2 C11.2132931,2 15,4 16,8 C15,12 11.2132931,14 8,14 Z M8,12 C10.209139,12 12,10.209139 12,8 C12,5.790861 10.209139,4 8,4 C5.790861,4 4,5.790861 4,8 C4,10.209139 5.790861,12 8,12 Z M8,10 C6.8954305,10 6,9.1045695 6,8 C6,6.8954305 6.8954305,6 8,6 C9.1045695,6 10,6.8954305 10,8 C10,9.1045695 9.1045695,10 8,10 Z" fillRule="nonzero" />
    </g>
  </BaseIcon>
);

export default PreviewIcon;




// WEBPACK FOOTER //
// ./src-react/DesignSystem/Icons/PreviewIcon.jsx